// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3360 ? "0a126bf1" : chunkId) + "." + {"1444":"c33aaf3c5c5b92f8","3360":"9f9065d242fb05aa","8457":"c500d72acd7bced5"}[chunkId] + ".js";
};